import { Typography } from '@mui/material'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step, { StepProps } from '@mui/material/Step';
import { styled } from '@mui/material/styles'
import { deepOrange, green } from '@mui/material/colors';
import StepButton from '@mui/material/StepButton';
import StepLabel, { StepLabelProps } from '@mui/material/StepLabel';
import { Switch, FormControlLabel, IconButton } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { StepIconProps } from '@mui/material/StepIcon';
import CircularProgress from '@mui/material/CircularProgress';
import { getPhase, getPendingMilestonesNoTimedout, hasTimedoutPhases } from '../utils';

import _ from 'lodash'
import React, { PropsWithChildren, useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppState } from 'src/store'
import {
    startFetchApp,
    startBuild,
    startCreate,
    startDestroy,
    startCompile,
    startInit,
    startBuildBackend,
    startLaunch,
    startStop,
    startPinging,
    startHeartbeat,
    stopHeartbeat,
    reset,
} from '../actions'
import * as types from '../types'
import { Milestone, AppPhase } from '../types'
import { DATE_FORMAT } from 'src/utils'
import CodeIcon from '@mui/icons-material/Code';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import StorageIcon from '@mui/icons-material/Storage';
import LuggageIcon from '@mui/icons-material/Luggage';
import StartIcon from '@mui/icons-material/PlayArrow';
import OnlineIcon from '@mui/icons-material/Sensors';
import OfflineIcon from '@mui/icons-material/SensorsOff';
import StopIcon from '@mui/icons-material/PowerSettingsNew';
import WarningIcon from '@mui/icons-material/Warning';
import TerminateIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { PING_TIMEOUT } from '../saga';


const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.light,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.success.light,
        },
    },
    [`&.${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[400],
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: StepProps & {
        timedout: boolean,
        error: boolean,
        pending: boolean
    };
}>(({ theme, ownerState }) => ({
    position: 'relative',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',

    ...(ownerState.active && {
        // backgroundImage: `linear-gradient( 136deg, ${theme.palette.primary.light} 20%, ${theme.palette.primary.dark} 100%)`,
        backgroundColor: theme.palette.primary.main,
        // boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        boxShadow: theme.shadows[7]
    }),

    ...(ownerState.completed && {
        // backgroundImage: `linear-gradient( 136deg, ${theme.palette.success.light} 20%, ${theme.palette.success.dark} 100%)`,
        backgroundColor: theme.palette.success.main,
        boxShadow: theme.shadows[2],
    }),

    ...(ownerState.timedout && {
        // backgroundImage: `linear-gradient( 136deg, ${theme.palette.error.light} 20%, ${theme.palette.error.dark} 100%)`,
        backgroundColor: theme.palette.warning.main,
        // backgroundColor: deepOrange[600],
    }),

    ...(ownerState.error && {
        // backgroundImage: `linear-gradient( 136deg, ${theme.palette.error.light} 20%, ${theme.palette.error.dark} 100%)`,
        backgroundColor: theme.palette.error.main,
        // backgroundColor: deepOrange[600],
    }),

    // ...(ownerState.active && ownerState.terminate && {
    // backgroundImage: `linear-gradient( 136deg, ${theme.palette.error.light} 20%, ${theme.palette.error.dark} 100%)`,
    // backgroundColor: theme.palette.error.main,
    // }),
}));

const ArcadeButtonRoot = styled('div')<{
    ownerState: {
        error?: boolean,
        pending?: boolean
    };
}>(({ theme, ownerState }) => ({
    position: 'relative',
    zIndex: 1,
    color: '#000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

const ArcadeButton: React.FC<PropsWithChildren<{ pending: boolean }>> = ({ children, pending }) => {
    const size: number = 16;
    return (
        <ArcadeButtonRoot ownerState={{ error: false, pending }}>
            {children}
            {pending && <CircularProgress
                size={size * 2}
                thickness={6}
                sx={{
                    color: theme => theme.palette.grey[500],
                    position: 'absolute',
                    top: '50%',
                    right: '6px',
                    marginTop: `${-size}px`,
                    marginLeft: `${-size}px`,
                }}
            />}
        </ArcadeButtonRoot>
    )
}

const labels: { [index: string]: string } = {
    [Milestone.Src]: 'Source',
    [Milestone.Bin]: 'Binaries',
    [Milestone.Db]: 'Storage',
    [Milestone.Backend]: 'Package',
    [Milestone.Running]: 'Launch',
    [Milestone.Ping]: 'Online',
    [Milestone.Stopped]: 'Stop',
    [Milestone.Erased]: 'Delete'
};

const getMilestoneLabel = (milestone: Milestone) => labels[milestone];

const icons: { [index: string]: React.ReactElement } = {
    [Milestone.Src]: <CodeIcon />,
    [Milestone.Bin]: <MiscellaneousServicesIcon />,
    [Milestone.Db]: <StorageIcon />,
    [Milestone.Backend]: <LuggageIcon />,
    [Milestone.Running]: <StartIcon />,
    [Milestone.Ping]: <OnlineIcon />,
    [Milestone.Stopped]: <StopIcon />,
    [Milestone.Erased]: <TerminateIcon />
};

const getStepIcon = (milestone: Milestone, timedout: boolean, error: boolean, pending: boolean) => (props: StepIconProps) => {
    const { active, completed, className } = props;
    const size: number = 23;

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active, timedout, error, pending }} className={className}>
            {icons[milestone]}
            {pending && <CircularProgress
                size={size * 2}
                thickness={4}
                sx={{
                    color: theme => theme.palette.success.main,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: `${-size}px`,
                    marginLeft: `${-size}px`,
                }}
            />}
        </ColorlibStepIconRoot>
    );
}

const DISABLED = false;
const SHOW_DETAILS_SWITCH = false;

const Application: React.FC<types.ApplicationConf> = ({ type, options }) => {
    const dispatch = useDispatch();
    const adminConsole = options?.admin || false;
    const { id } = useParams<{ id?: string }>();
    const [expertMode, setExpertMode] = useState(adminConsole);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(false);
    const [stoppable, setStoppable] = useState(false);

    const state: types.ApplicationState = useSelector((state: AppState) => state.ext_app.application);
    const application: types.Application | null = state.application;
    const baseUrl: string = useSelector((state: AppState) => state.global.options.baseUrl)!;
    const isRunning = application?.isSuccess([Milestone.Running])
    const unreachable = state.pingTimedOut || state.heartbeatFail;
    const accessible = isRunning && !unreachable && state.lastPinged !== null;
    const online = accessible && !busy;

    useEffect(() => {
        if (!DISABLED && id != null) {
            dispatch(startFetchApp(parseInt(id)));
        }
        return () => {
            dispatch(reset());
        }
    }, []);

    useEffect(() => {
        if (
            !DISABLED &&
            state.application !== null
            && !state.pingTimedOut
            && application?.isSuccess([Milestone.Running])
            && state.lastPinged === null
            && state.isPinging === false
        ) {
            handlers[Milestone.Ping]();
        }
    }, [state.application?.milestones?.[Milestone.Running], state.application?.id]);

    useEffect(() => {
        setBusy(
            state.application !== null && (
                getPendingMilestonesNoTimedout(state).length > 0
                || state.optimisticStart !== null
                || state.isPinging
                // || state.isBuilding
            )
        );
        setError(
            state.application !== null && (
                state.application.getErrorMilestones().length > 0
                || hasTimedoutPhases(state)
                || state.pingTimedOut
            )
        );

    }, [state]);

    useEffect(() => {
        setStoppable(
            application !== null
            && state.lastPinged !== null
            && application.isAvail([Milestone.Stopped])
            && application.isSuccess([Milestone.Src, Milestone.Bin, Milestone.Db, Milestone.Backend, Milestone.Running])
        );
    }, [application, state.lastPinged]);

    const handleGoToApp = useCallback(() => {
        if (online) {
            window.open(
                baseUrl + '/app/' + state.application!.appPath,
                '_blank'
            )!.focus();
        }
    }, [state.application, online]);

    const handleBuild = () => { dispatch(startBuild(parseInt(id || ''))) }

    const handlers: { [index: string]: () => void } = {
        [Milestone.Src]: () => {
            dispatch(startCreate(parseInt(id || '')));
        },
        [Milestone.Bin]: () => {
            dispatch(startCompile(parseInt(id || '')));
        },
        [Milestone.Db]: () => {
            dispatch(startInit(parseInt(id || '')));
        },
        [Milestone.Backend]: () => {
            dispatch(startBuildBackend(parseInt(id || '')));
        },
        [Milestone.Running]: () => {
            dispatch(startLaunch(parseInt(id || ''), state.application!.appPath));
        },
        [Milestone.Ping]: () => {
            dispatch(startPinging(state.application!.appPath, PING_TIMEOUT));
        },
        [Milestone.Stopped]: () => {
            dispatch(startStop(parseInt(id || '')));
        },
        [Milestone.Erased]: () => {
            dispatch(startDestroy(parseInt(id || '')));
        }
    };

    const getStepButtonHandler = (milestone: Milestone) => handlers[milestone];

    const isStepError: (milestone: Milestone) => boolean = (milestone) => {
        if (milestone === Milestone.Ping && state.pingTimedOut) {
            return true;
        }
        return application?.isError([milestone]) || false;
    }

    const isStepTimedout: (milestone: Milestone) => boolean = (milestone) => {
        return state.phases[getPhase(milestone)].timedout;
    }

    const isStepSuccess: (milestone: Milestone) => boolean = (milestone) => {
        if (milestone === Milestone.Ping) {
            return state.lastPinged !== null;
        }
        return application?.isSuccess([milestone]) || false;
    }

    const isStepReady: (milestone: Milestone) => boolean = (milestone) => {
        if (application === null) {
            return false;
        }
        if (milestone === Milestone.Src) {
            return application.isAvail([milestone]);

        } else if (milestone === Milestone.Bin) {
            return application.isAvail([milestone]) && application.isSuccess([Milestone.Src]);

        } else if (milestone === Milestone.Db) {
            return application.isAvail([milestone]) && application.isSuccess([Milestone.Src, Milestone.Bin]);

        } else if (milestone === Milestone.Backend) {
            return application.isAvail([milestone]) && application.isSuccess([Milestone.Src, Milestone.Bin, Milestone.Db]);

        } else if (milestone === Milestone.Running) {
            return application.isAvail([milestone]) && application.isSuccess([Milestone.Src, Milestone.Bin, Milestone.Db, Milestone.Backend]);

        } else if (milestone === Milestone.Ping) {
            return state.lastPinged === null && application.isSuccess([Milestone.Src, Milestone.Bin, Milestone.Db, Milestone.Backend, Milestone.Running]);

        } else if (milestone === Milestone.Stopped) {
            return stoppable;

        } else if (milestone === Milestone.Erased) {
            return state.pingTimedOut
                || (
                    application.isSuccess([Milestone.Src])
                    && !application.isSuccess([Milestone.Running])
                    && application.getPendingMilestones().length === 0
                    && state.optimisticStart === null
                );
        }
        return false;
    }

    const isStepPending: (milestone: Milestone) => boolean = (milestone) => {
        if (application === null) {
            return false;
        }
        if (milestone === Milestone.Ping) {
            return state.isPinging;
        }
        return !isStepTimedout(milestone) && (application.isPending([milestone]) || state.optimisticStart?.milestone === milestone);
    }

    const getSuccessTime: (milestone: Milestone) => string | null = (milestone) => {
        return isStepSuccess(milestone) ? (
            milestone === Milestone.Ping ?
                state.lastPinged?.format(DATE_FORMAT) || null
                :
                application?.getMoment(milestone, types.MilestoneDetail.Success)?.format(DATE_FORMAT) || null
        ) : null;
    }

    const getErrorTime: (milestone: Milestone) => string | null = (milestone) => {
        return isStepError(milestone) ? (
            milestone === Milestone.Ping ?
                state.lastPinged?.format(DATE_FORMAT) || null
                :
                application?.getMoment(milestone, types.MilestoneDetail.Error)?.format(DATE_FORMAT) || null
        ) : null;
    }

    const getStartedTime: (milestone: Milestone) => string | null = (milestone) => {
        return application?.getMoment(milestone, types.MilestoneDetail.Started)?.format(DATE_FORMAT) || null
    }

    return (
        <div>
            {
                !DISABLED && <div className={'biz-application-dashboard'}>

                    {
                        SHOW_DETAILS_SWITCH && adminConsole && <Box
                            display='flex'
                            flexDirection='column'
                            justifyContent="center"
                            alignItems="center"
                        >
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={expertMode}
                                        onChange={
                                            (e) => {
                                                setExpertMode(e.target.checked);
                                            }
                                        }
                                    />
                                }
                                label={
                                    <Typography
                                        sx={{
                                            color: theme => theme.palette.text.secondary,
                                            fontWeight: theme => theme.typography.fontWeightBold
                                        }}
                                    >
                                        {'Details'}
                                    </Typography>
                                }
                            />
                        </Box>
                    }

                    {expertMode &&
                        <Box sx={{ mt: 2, mb: 0 }}>
                            <Stepper nonLinear alternativeLabel connector={<QontoConnector />}>
                                {
                                    [
                                        Milestone.Src,
                                        Milestone.Bin,
                                        Milestone.Db,
                                        Milestone.Backend,
                                        Milestone.Running,
                                        Milestone.Ping,
                                        Milestone.Stopped,
                                        Milestone.Erased
                                    ].map((milestone, index) => {
                                        const labelProps: StepLabelProps = {};

                                        const startedTime = getStartedTime(milestone);
                                        const successTime = getSuccessTime(milestone);
                                        const errorTime = getErrorTime(milestone);

                                        const ready: boolean = isStepReady(milestone);
                                        const pending: boolean = isStepPending(milestone);
                                        const success: boolean = isStepSuccess(milestone);
                                        const error: boolean = isStepError(milestone);
                                        const timedout: boolean = isStepTimedout(milestone);

                                        labelProps.optional = (
                                            <>
                                                <Typography variant="subtitle2" color={error ? 'error' : timedout ? 'warning.dark' : success ? 'success.dark' : undefined} component="div">
                                                    {error ? '(Error)' : timedout ? '(Timeout)' : success ? '(Completed)' : ''}
                                                </Typography>
                                                {
                                                    (application?.migration == milestone) && <Typography variant="subtitle2" color="secondary.dark" component="div">
                                                        {'(Migration in progress...)'}
                                                    </Typography>
                                                }
                                            </>
                                        );

                                        const stepProps: StepProps = {
                                            disabled: !ready || pending || error || timedout,
                                            active: ready && !error && !timedout,
                                            completed: success || error || timedout
                                        }

                                        return (
                                            <Tooltip
                                                title={
                                                    startedTime != null ? <div>
                                                        {
                                                            <div>{`Started at: ${startedTime}`}</div>
                                                        }
                                                        {
                                                            successTime != null && <div>{`Completed at: ${successTime}`}</div>
                                                        }
                                                        {
                                                            errorTime != null && <div>{`Failed at: ${errorTime}`}</div>
                                                        }
                                                    </div> : <div>{'Not started'}</div>
                                                }
                                                key={index}
                                            >
                                                <Step key={index} {...stepProps}>
                                                    <StepButton
                                                        icon={
                                                            <StepLabel
                                                                {...labelProps}
                                                                StepIconComponent={getStepIcon(milestone, timedout, error, pending)}
                                                            >
                                                                {getMilestoneLabel(milestone)}
                                                            </StepLabel>
                                                        }
                                                        onClick={() => {
                                                            getStepButtonHandler(milestone)();
                                                        }}
                                                    >
                                                    </StepButton>
                                                </Step>
                                            </Tooltip>
                                        );
                                    })
                                }
                            </Stepper>
                        </Box>
                    }

                    <Box
                        display='flex'
                        flexDirection='column'
                        justifyContent="center"
                        alignItems="center">

                        <IconButton
                            size='large'
                            onClick={handleGoToApp}
                            disabled={!online}
                        >
                            <Stack
                                direction="column"
                                spacing={0}
                                alignItems='center'
                            >
                                {
                                    online ?
                                        <OnlineIcon fontSize='large' sx={{ color: theme => theme.palette.success.main }} />
                                        :
                                        <OfflineIcon fontSize='large' />
                                }
                            </Stack>
                        </IconButton>
                        <Typography
                            sx={{
                                color: (theme) => online ? theme.palette.success.main : 'inherit'
                            }}
                            variant="button"
                        >
                            {online ? 'online' : 'offline'}
                        </Typography>

                        {
                            <ArcadeButton pending={busy}>
                                <Button
                                    variant="contained"
                                    endIcon={stoppable ? <StopIcon /> : error ? <WarningIcon /> : <StartIcon />}
                                    onClick={stoppable ? handlers[Milestone.Stopped] : error ? undefined : handleBuild}
                                    disabled={busy}
                                    color={stoppable ? "success" : error ? "error" : "success"}
                                >
                                    {stoppable ? "Stop" : error ? "Error" : "Launch"}
                                </Button>
                            </ArcadeButton>
                        }

                    </Box>

                    {/* {
                expertMode && <div>
                    <button
                        disabled={busy}
                        onClick={handleHeartbeatStart}>
                        {'Heartbeat Start'}
                    </button>
                    <button
                        disabled={busy}
                        onClick={handleHeartbeatStop}>
                        {'Heartbeat Stop'}
                    </button>
                </div>
            } */}

                </div>
            }
        </div>
    )
}

export default Application
